import React, { MouseEventHandler } from 'react'
import { useDownloadWorkpapersByAudit } from 'src/pages/Audit/AuditIndexPage/ItemMenu/DownloadWorkPapers'
import { useConfirmationContext } from '../../../../../Confirmation'
import { Spinner, useThrobberContext } from '../../../../../Throbber'
import { useInAudit } from '../../../../../context/AuditContext'

export const mimicAnchorDownload = (url: string): undefined => {
  const tag = document.createElement('a')
  tag.setAttribute('href', url)
  tag.setAttribute('download', '')
  tag.click()
  return
}

export const useDownloadWorkPapers =
  (): MouseEventHandler<HTMLButtonElement> => {
    const downloadWorkpapers = useDownloadWorkpapersByAudit()
    const { auditId } = useInAudit()
    const { setConfirmationState } = useConfirmationContext()
    const { setThrobberState } = useThrobberContext()

    return () => {
      setConfirmationState({
        isShown: true,
        size: 'lg',
        title: 'Export Work Papers Into a Zip',
        body: (
          <p>
            Trustero will gather the following data to create a zip file of work
            papers including all the policies, controls, and evidence grouped by
            controls. We will email you a link to download this file once its
            ready.
          </p>
        ),
        confirmText: 'Export Work Papers',
        onConfirmCB: async () => {
          setThrobberState({
            isShown: true,
            Display: <Spinner color="primary" size="xl" />,
          })
          try {
            await downloadWorkpapers(undefined, auditId) // has error handling internally
          } finally {
            setThrobberState({
              isShown: false,
              Display: <></>,
            })
          }
        },
      })
    }
  }
